import { useEffect, useRef } from "react"
import videojs from "video.js"
import Player from "video.js/dist/types/player"
import "video.js/dist/video-js.css"

type VideoPlayerProps = {
  options: any
  onReady?: (arg: Player) => void
  size?: "extrasmall" | "small" | "medium" | "large"
} & React.HTMLAttributes<HTMLDivElement>

export const VideoPlayer: React.FC<VideoPlayerProps> = ({ options, onReady, size, ...props }) => {
  const videoRef = useRef<HTMLDivElement>(null)
  const playerRef = useRef<any>(null)

  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement("video-js")

      videoElement.classList.add("vjs-big-play-centered")
      videoElement.classList.add(`vjs-custom-${size ?? "medium"}-layout`)
      videoRef.current?.appendChild(videoElement)

      const player: Player = (playerRef.current = videojs(videoElement, options, () => {
        onReady && onReady(player)
      }))
    } else {
      const player = playerRef.current

      player?.autoplay(options.autoplay)
      player?.src(options.sources)
    }
  }, [options, videoRef])

  // Dispose the Video.js player when the functional component unmounts
  useEffect(() => {
    const player = playerRef.current

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose()
        playerRef.current = null
      }
    }
  }, [playerRef])

  return (
    <div data-vjs-player {...props}>
      <div ref={videoRef} />
    </div>
  )
}
